/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Systemsettings_Themesystemdescription3Inputs */

const zh_systemsettings_themesystemdescription3 = /** @type {(inputs: Systemsettings_Themesystemdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跟随设备当前的系统主题。`)
};

const en_systemsettings_themesystemdescription3 = /** @type {(inputs: Systemsettings_Themesystemdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow your device system theme.`)
};

const es_systemsettings_themesystemdescription3 = /** @type {(inputs: Systemsettings_Themesystemdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguir el tema del sistema del dispositivo.`)
};

/**
* | output |
* | --- |
* | "Follow your device system theme." |
*
* @param {Systemsettings_Themesystemdescription3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const systemsettings_themesystemdescription3 = /** @type {((inputs?: Systemsettings_Themesystemdescription3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Systemsettings_Themesystemdescription3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_systemsettings_themesystemdescription3(inputs)
	if (locale === "en") return en_systemsettings_themesystemdescription3(inputs)
	return es_systemsettings_themesystemdescription3(inputs)
});
export { systemsettings_themesystemdescription3 as "systemSettings_themeSystemDescription" }